import { FormFieldTypes } from "../../../../../data/formFieldType";

export const industryTechnicalCommitteesData = {
    name: 'IndustryTechnicalCommittees',
    initialState: {
        nameofIndustryTechnicalCommittee: '',
        instituteThatCommitteeResidesin: '',
        dateofAppointment: "",
        EmailLetterofAppointment: "",
        CpdPoints: "",
        remarks: "",
        processedBy: "",
        cpdPointsAwarded: "",
        notes: "",
    },
    formFields: [
        {
            id: "industryInformation",
            lable: "",
            Field_Name: "industryInformation",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "industryInformation",
            fieldSetting: {
                formTitle: "Industry Information",
            },
            style: {
                containerCss: "col-lg-12 mb-4 text-left",
            },
        },
        {
            id: "nameofIndustryTechnicalCommittee",
            lable: "Name of Industry Technical Committee",
            Field_Name: "Name of Industry Technical Committee",
            fieldType: FormFieldTypes.INPUT,
            dataField: "nameofIndustryTechnicalCommittee",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        {
            id: "instituteThatCommitteeResidesin",
            lable: "Institute that committee resides in",
            Field_Name: "Institute that committee resides in",
            fieldType: FormFieldTypes.INPUT,
            dataField: "instituteThatCommitteeResidesin",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space",
            },
        },
        {
            id: "dateofAppointment",
            lable: "Date of Appointment",
            Field_Name: "Date of Appointment",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "dateofAppointment",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        {
            id: "EmailLetterofAppointment",
            lable: 'Email/Letter of Appointment',
            subLable: '(please upload in pdf/jpg format max 2mb)',
            Field_Name: 'file',
            fieldType: FormFieldTypes.FILE,

            dataField: 'EmailLetterofAppointment',
            fieldSetting: {
                // presentFileName: null,
                placeholder: 'Select Profile Photo',
                isDownloadable: true,
                acceptedFiles: '.pdf,.jpg,.jpeg,.png',
                maxFileSizeInKB: 2048,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        // {
        //     fieldType: FormFieldTypes.SEPARATOR,
        //     style: {
        //         containerCss: "separation-line pl-0 pr-0",
        //     },
        // },
        {
            id: "CpdPoints",
            lable: "CPD Points",
            Field_Name: "CPD Points",
            fieldType: FormFieldTypes.INPUT,
            dataField: "CpdPoints",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space",
            },
        },
        {
            id: "remarks",
            lable: "Remarks",
            Field_Name: "Remarks",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "remarks",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            // validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 col-12 input-margin-space",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "sgbcSection",
            lable: "",
            Field_Name: "sgbcSection",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "sgbcSection",
            fieldSetting: {
                formTitle: "SGBC Section",
            },
            style: {
                containerCss: "col-lg-12 mb-4 text-left",
            },
        },
        {
            id: "processedBy",
            lable: "Processed by",
            Field_Name: "Processed by",
            fieldType: FormFieldTypes.SELECT,
            dataField: "processedBy",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6  "
            }
        },
        {
            id: "cpdPointsAwarded",
            lable: "CPD Points Awarded",
            Field_Name: "CPD Points Awarded ",
            fieldType: FormFieldTypes.SELECT,
            dataField: "cpdPointsAwarded",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6"
            }
        },
        {
            id: "notes",
            lable: "Notes",
            Field_Name: "Notes",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "notes",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3",
            },
        },
        {
            id: "rejectCPDSubmissionReason",
            lable: "Reason Of Rejection",
            Field_Name: "Reason Of Rejection",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "rejectCPDSubmissionReason",
            fieldSetting: {
                placeholder: "",
                maxLength:400,
            },
            
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3"
            }
        },

    ],
    formSetting: {
        isViewOnly: false
    }
}